import { render, staticRenderFns } from "./ActivateUserAction.vue?vue&type=template&id=08d278e7"
import script from "./ActivateUserAction.vue?vue&type=script&lang=js"
export * from "./ActivateUserAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports